import actions from '../actions';
import { ReducerBuilder } from './reducer-builder';
import { createTheme } from '@mui/material/styles';

const defaultTheme = createTheme({
  palette: {
    primary: {
      light: '#63a4ff',
      main: '#6ea7d2',
      dark: '#3F7CB6',
      contrastText: '#fff',
    },
    secondary: {
      light: '#63a4ff',
      main: '#3F7CB6',
      dark: '#6ea7d2',
      contrastText: '#fff',
    },
    common: {
      white: '#fff',
      lightBlue: '#D6EBF2',
    }
  },
  typography: {
    useNextVariants: true,
  },
});

const defaultState = {
  activeTheme: defaultTheme,
  themes: [
    defaultTheme
  ]
};

const reducer = new ReducerBuilder(defaultState)
  .handle(actions.app.themes.createThemeSuccess, (state, action) => ({
    ...state,
    themes: [
      ...state.themes,
      action.payload.theme
    ],
  }))
  .handle(actions.app.themes.setTheme, (state, action) => ({
    ...state,
    activeTheme: {
      ...action.payload.theme
    },
  }))
  .handle(actions.app.themes.updateThemeFromAccount, (state, action) => {
    const { accountDetails } = action.payload;
    
    const primaryColor =
      (accountDetails &&
        accountDetails.extensionData &&
        accountDetails.extensionData.extensionData &&
        accountDetails.extensionData.extensionData.Themes &&
        accountDetails.extensionData.extensionData.Themes.primary) ||
      '#6ea7d2';

    const secondaryColor =
      (accountDetails &&
        accountDetails.extensionData &&
        accountDetails.extensionData.extensionData &&
        accountDetails.extensionData.extensionData.Themes &&
        accountDetails.extensionData.extensionData.Themes.secondary) ||
      '#3F7CB6';

    const updatedTheme = createTheme({
      palette: {
        primary: {
          light: '#63a4ff',
          main: primaryColor,
          dark: '#3F7CB6',
          contrastText: '#fff',
        },
        secondary: {
          light: '#63a4ff',
          main: secondaryColor,
          dark: '#6ea7d2',
          contrastText: '#fff',
        },
        common: {
          white: '#fff',
          lightBlue: '#D6EBF2',
        }
      },
      typography: {
        useNextVariants: true,
      },
    });

    return {
      ...state,
      activeTheme: updatedTheme,
    };
  })
  .handle(actions.app.auth.logoutSuccess, () => defaultState)
  .done();

export default reducer;